import { useCallback } from 'react';

import styles from './styles';
import type { IConfirmationDialogProps } from './types';
import { DialogContainer } from '@frontierag/frontier-ui-library';

const ConfirmationDialog = ({
  open,
  title,
  message,
  onAction,
  onActionLabel,
  onClose,
  closeLabel = 'Close',
}: IConfirmationDialogProps) => {
  const actionButton = { title: onActionLabel, onActionClick: onAction };
  const dialogActions = [actionButton];

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <DialogContainer
      sx={styles}
      open={open}
      onClose={handleClose}
      title={title}
      closeLabel={closeLabel}
      actions={dialogActions}
    >
      {message}
    </DialogContainer>
  );
};

export default ConfirmationDialog;
